/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * All supported DID methods. Default is "web".
 */
export type CredentialSignRequestDidMethod = 'key' | 'web';
export const CredentialSignRequestDidMethod = {
    Key: 'key',
    Web: 'web',
} as const;
